// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1d5aJ","item":"PaymentsMobile_item__3-O8f","label":"PaymentsMobile_label__1vR_k","amount":"PaymentsMobile_amount__3dEFV"};